import { IElement } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { IPickProposed } from "core-integration/src/store/my-team/types";

/**
 * Organizes player picks into starting players and bench players based on a chip,
 * and groups the starting players by their element type.
 *
 * @param picks - List of player picks
 * @param elementsById - Object mapping element IDs to element objects
 * @param chipName - Active chip name (optional)
 * @returns Object containing bench players and players grouped by element type
 */
export const getStartingAndBenchPlayers = <
  T extends IPickLight | IPickProposed,
>(
  picks: T[],
  elementsById: Record<number, IElement>,
  chipName: string | null,
): {
  benchPlayers: T[];
  playersByElementType: Record<string, T[]>;
} => {
  // Determine team size based on chip in play
  const teamCount = chipName === "bboost" ? 15 : 11;

  // Find starting players (positions 1-11) and bench players (positions 12+)
  const startingPlayers = picks.filter((p) => p.position <= teamCount);
  const benchPlayers = picks.filter((p) => p.position > teamCount);

  // Group starting players by element type
  const playersByElementType: Record<string, T[]> = {};

  startingPlayers.forEach((pick) => {
    const element = elementsById[pick.element];
    const elementTypeId = element?.element_type.toString() || "0";

    if (!playersByElementType[elementTypeId]) {
      playersByElementType[elementTypeId] = [];
    }

    playersByElementType[elementTypeId].push(pick);
  });

  return {
    playersByElementType,
    benchPlayers,
  };
};
